export default "__VITE_ASSET__l8Gv90xF__"